import { render } from "./VacancyPillCell.vue?vue&type=template&id=01a04011&scoped=true"
import script from "./VacancyPillCell.vue?vue&type=script&lang=js"
export * from "./VacancyPillCell.vue?vue&type=script&lang=js"

import "./VacancyPillCell.vue?vue&type=style&index=0&id=01a04011&lang=scss&scoped=true"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a04011"]])

export default __exports__